import likeOrDisLike from "@/api/module/likeOrDisLike";
import bizSupplier from "@/api/openBusinese/bizSupplier.js";

// 统一注册API
const api = { likeOrDisLike , bizSupplier};

export default api;
